/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type CreateWebhookBodyEventsItem = typeof CreateWebhookBodyEventsItem[keyof typeof CreateWebhookBodyEventsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateWebhookBodyEventsItem = {
  '': '*',
} as const;
